// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 560 ? "fcfb803e" : chunkId) + "." + {"560":"ea405ce75e32d44a","605":"850e67eeeb03bcb5"}[chunkId] + ".js";
};